 
import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({
  name: 'normalizeRteSpacing',
  standalone: true
})
export class NormalizeRteSpacingPipe implements PipeTransform {

  transform(html: string | null | undefined): string {

    if (!html) {
      return '';
    }

    return html.replace(
      /&nbsp;|&#160;|&#xA0;|\u00A0|\u202F/gi,
      ' '
    );

  }

}
